var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 219,
    viewBox: "0 0 250 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.046 35.8547C207.046 35.8547 183.412 19.2107 151.721 25.6011C120.029 31.9915 106.064 53.8039 87.5163 68.5776C77.7886 76.3127 63.737 78.9232 52.3013 84.7836C15.7327 103.53 19.5357 147.667 46.6076 164.938C70.0645 179.865 99.9457 182.063 139.264 172.384C178.583 162.704 206.686 156.913 231.9 127.108C257.113 97.3017 236.052 58.4029 207.046 35.8547Z",
    fill: "#B0BEC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M207.046 35.8547C207.046 35.8547 183.412 19.2107 151.721 25.6011C120.029 31.9915 106.064 53.8039 87.5163 68.5776C77.7886 76.3127 63.737 78.9232 52.3013 84.7836C15.7327 103.53 19.5357 147.667 46.6076 164.938C70.0645 179.865 99.9457 182.063 139.264 172.384C178.583 162.704 206.686 156.913 231.9 127.108C257.113 97.3017 236.052 58.4029 207.046 35.8547Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.315 36.792H56.1602V149.415H211.315V36.792Z",
    fill: "#B0BEC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M211.315 36.792H56.1602V149.415H211.315V36.792Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.39 54.8989H83.2754V147.921H210.39V54.8989Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.006 139.547H206.556",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.006 139.547V138.842",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.555 139.547V138.842",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.365 139.547V111.217",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.365 139.547H124.58",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.365 136.008H124.58",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.365 132.464H124.58",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.365 128.925H124.58",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.365 125.382H124.58",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.365 121.843H124.58",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.365 118.299H124.58",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M122.365 114.76H124.58",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.365 111.217H124.58",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M197.425 118.299H192.52V139.547H197.425V118.299Z",
    fill: "#A1A1A1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M191.979 134.238H187.074V139.551H191.979V134.238Z",
    fill: "#B0BEC5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M186.53 133.174H181.625V139.547H186.53V133.174Z",
    fill: "#A1A1A1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M181.081 121.843H176.176V139.551H181.081V121.843Z",
    fill: "#B0BEC5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M175.63 128.925H170.725V139.551H175.63V128.925Z",
    fill: "#A1A1A1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M170.18 130.695H165.275V139.547H170.18V130.695Z",
    fill: "#B0BEC5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.729 132.464H159.824V139.547H164.729V132.464Z",
    fill: "#A1A1A1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M159.28 114.76H154.375V139.551H159.28V114.76Z",
    fill: "#B0BEC5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M153.835 136.008H148.93V139.551H153.835V136.008Z",
    fill: "#A1A1A1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M148.385 128.925H143.48V139.551H148.385V128.925Z",
    fill: "#B0BEC5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M142.934 121.843H138.029V139.551H142.934V121.843Z",
    fill: "#A1A1A1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M137.485 125.382H132.58V139.547H137.485V125.382Z",
    fill: "#B0BEC5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M132.036 132.464H127.131V139.547H132.036V132.464Z",
    fill: "#A1A1A1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2402 97.6213H203.81",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2402 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M93.375 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5098 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M105.645 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M111.779 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M117.916 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M124.051 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M130.186 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M136.32 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M142.461 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M148.596 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M154.73 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M160.865 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M167 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M173.135 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M179.27 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M185.404 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M191.541 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M197.676 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M203.811 97.6214V96.6184",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2402 97.6215V57.5664",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2402 97.6213H90.1552",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2402 89.6104H90.1552",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2402 81.5994H90.1552",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2402 73.5884H90.1552",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2402 65.5774H90.1552",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2402 57.5664H90.1552",
    stroke: "#8C8C8C",
    strokeWidth: 0.51243,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4455 65.5774L90.3105 89.6105",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M102.58 79.1948L96.4453 65.5774",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M108.715 73.5884L102.58 79.1948",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M114.85 88.0073L108.715 73.5884",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M120.985 65.5774L114.85 88.0074",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M127.119 57.5664L120.984 65.5774",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M133.256 93.6138L127.121 57.5664",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M139.391 91.2092L133.256 93.6138",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M145.526 90.4075L139.391 91.209",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M151.66 88.0073L145.525 90.4076",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M157.795 84.8013L151.66 88.0074",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M163.93 86.4044L157.795 84.8013",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M170.065 89.6105L163.93 86.4043",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M176.199 72.7869L170.064 89.6104",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M182.334 70.3823L176.199 72.7869",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M188.471 67.1804L182.336 70.3822",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M194.606 70.3822L188.471 67.1804",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M200.74 73.5885L194.605 70.3823",
    stroke: "#B0BEC5",
    strokeWidth: 2.04972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3096 88.6599C90.5974 88.6599 90.8733 88.76 91.0768 88.9383C91.2803 89.1165 91.3946 89.3583 91.3946 89.6104C91.3933 89.8617 91.2784 90.1023 91.0751 90.2796C90.8717 90.4569 90.5965 90.5565 90.3096 90.5565C90.0227 90.5565 89.7475 90.4569 89.5442 90.2796C89.3408 90.1023 89.2259 89.8617 89.2246 89.6104C89.2246 89.3583 89.3389 89.1165 89.5424 88.9383C89.7459 88.76 90.0218 88.6599 90.3096 88.6599Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4444 64.627C96.7321 64.627 97.0081 64.7271 97.2116 64.9053C97.4151 65.0836 97.5294 65.3253 97.5294 65.5774C97.5294 65.8295 97.4151 66.0712 97.2116 66.2495C97.0081 66.4277 96.7321 66.5279 96.4444 66.5279C96.1566 66.5279 95.8806 66.4277 95.6772 66.2495C95.4737 66.0712 95.3594 65.8295 95.3594 65.5774C95.3594 65.3253 95.4737 65.0836 95.6772 64.9053C95.8806 64.7271 96.1566 64.627 96.4444 64.627Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M102.581 78.2444C102.869 78.2444 103.145 78.3445 103.348 78.5228C103.552 78.701 103.666 78.9428 103.666 79.1948C103.666 79.4469 103.552 79.6887 103.348 79.8669C103.145 80.0452 102.869 80.1453 102.581 80.1453C102.293 80.1453 102.017 80.0452 101.814 79.8669C101.61 79.6887 101.496 79.4469 101.496 79.1948C101.496 78.9428 101.61 78.701 101.814 78.5228C102.017 78.3445 102.293 78.2444 102.581 78.2444Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M108.716 72.6379C109.003 72.6379 109.278 72.7375 109.481 72.9148C109.685 73.0921 109.8 73.3327 109.801 73.584C109.801 73.8361 109.687 74.0779 109.483 74.2561C109.28 74.4343 109.004 74.5345 108.716 74.5345C108.428 74.5345 108.152 74.4343 107.949 74.2561C107.745 74.0779 107.631 73.8361 107.631 73.584C107.632 73.3327 107.747 73.0921 107.95 72.9148C108.154 72.7375 108.429 72.6379 108.716 72.6379Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M114.851 87.0569C115.138 87.0569 115.414 87.157 115.618 87.3353C115.821 87.5135 115.936 87.7553 115.936 88.0073C115.936 88.2594 115.821 88.5012 115.618 88.6794C115.414 88.8577 115.138 88.9578 114.851 88.9578C114.563 88.9578 114.287 88.8577 114.083 88.6794C113.88 88.5012 113.766 88.2594 113.766 88.0073C113.766 87.7553 113.88 87.5135 114.083 87.3353C114.287 87.157 114.563 87.0569 114.851 87.0569Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M121.001 64.627C121.289 64.627 121.565 64.7271 121.768 64.9053C121.972 65.0836 122.086 65.3253 122.086 65.5774C122.086 65.8295 121.972 66.0712 121.768 66.2495C121.565 66.4277 121.289 66.5279 121.001 66.5279C120.713 66.5279 120.437 66.4277 120.234 66.2495C120.03 66.0712 119.916 65.8295 119.916 65.5774C119.916 65.3253 120.03 65.0836 120.234 64.9053C120.437 64.7271 120.713 64.627 121.001 64.627Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M127.12 56.616C127.408 56.616 127.684 56.7161 127.887 56.8944C128.091 57.0726 128.205 57.3143 128.205 57.5664C128.205 57.8185 128.091 58.0603 127.887 58.2385C127.684 58.4167 127.408 58.5169 127.12 58.5169C126.832 58.5169 126.556 58.4167 126.353 58.2385C126.149 58.0603 126.035 57.8185 126.035 57.5664C126.035 57.3143 126.149 57.0726 126.353 56.8944C126.556 56.7161 126.832 56.616 127.12 56.616Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M133.255 92.6633C133.397 92.6633 133.538 92.6879 133.67 92.7357C133.802 92.7834 133.921 92.8535 134.022 92.9417C134.123 93.03 134.203 93.1348 134.257 93.2501C134.312 93.3654 134.34 93.489 134.34 93.6138C134.34 93.7386 134.312 93.8622 134.257 93.9775C134.203 94.0928 134.123 94.1976 134.022 94.2859C133.921 94.3741 133.802 94.4441 133.67 94.4919C133.538 94.5397 133.397 94.5642 133.255 94.5642C132.967 94.5642 132.691 94.4641 132.488 94.2859C132.284 94.1076 132.17 93.8659 132.17 93.6138C132.17 93.3617 132.284 93.12 132.488 92.9417C132.691 92.7635 132.967 92.6633 133.255 92.6633Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M139.39 90.2629C139.677 90.2629 139.952 90.3625 140.155 90.5398C140.358 90.7171 140.473 90.9577 140.475 91.209C140.475 91.4611 140.36 91.7029 140.157 91.8811C139.953 92.0593 139.677 92.1595 139.39 92.1595C139.102 92.1595 138.826 92.0593 138.622 91.8811C138.419 91.7029 138.305 91.4611 138.305 91.209C138.306 90.9577 138.421 90.7171 138.624 90.5398C138.828 90.3625 139.103 90.2629 139.39 90.2629Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M145.524 89.4614C145.811 89.4614 146.087 89.561 146.29 89.7383C146.493 89.9156 146.608 90.1562 146.609 90.4075C146.609 90.5323 146.581 90.6559 146.527 90.7712C146.472 90.8865 146.392 90.9913 146.292 91.0796C146.191 91.1678 146.071 91.2379 145.94 91.2856C145.808 91.3334 145.667 91.358 145.524 91.358C145.237 91.358 144.961 91.2578 144.757 91.0796C144.554 90.9013 144.439 90.6596 144.439 90.4075C144.441 90.1562 144.556 89.9156 144.759 89.7383C144.962 89.561 145.238 89.4614 145.524 89.4614Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M151.659 87.0569C151.947 87.0569 152.223 87.157 152.426 87.3353C152.63 87.5135 152.744 87.7553 152.744 88.0073C152.744 88.2594 152.63 88.5012 152.426 88.6794C152.223 88.8577 151.947 88.9578 151.659 88.9578C151.371 88.9578 151.095 88.8577 150.892 88.6794C150.689 88.5012 150.574 88.2594 150.574 88.0073C150.574 87.7553 150.689 87.5135 150.892 87.3353C151.095 87.157 151.371 87.0569 151.659 87.0569Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M157.796 83.8508C158.084 83.8508 158.36 83.951 158.563 84.1292C158.767 84.3075 158.881 84.5492 158.881 84.8013C158.881 85.0534 158.767 85.2951 158.563 85.4734C158.36 85.6516 158.084 85.7517 157.796 85.7517C157.508 85.7517 157.232 85.6516 157.029 85.4734C156.825 85.2951 156.711 85.0534 156.711 84.8013C156.711 84.5492 156.825 84.3075 157.029 84.1292C157.232 83.951 157.508 83.8508 157.796 83.8508Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M163.931 85.4539C164.073 85.4539 164.214 85.4784 164.346 85.5262C164.478 85.574 164.597 85.644 164.698 85.7322C164.799 85.8205 164.879 85.9253 164.933 86.0406C164.988 86.1559 165.016 86.2795 165.016 86.4043C165.016 86.5291 164.988 86.6527 164.933 86.768C164.879 86.8834 164.799 86.9881 164.698 87.0764C164.597 87.1647 164.478 87.2347 164.346 87.2824C164.214 87.3302 164.073 87.3548 163.931 87.3548C163.643 87.3548 163.367 87.2546 163.163 87.0764C162.96 86.8981 162.846 86.6564 162.846 86.4043C162.846 86.1522 162.96 85.9105 163.163 85.7322C163.367 85.554 163.643 85.4539 163.931 85.4539Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M170.065 88.6599C170.353 88.6599 170.629 88.76 170.833 88.9383C171.036 89.1165 171.15 89.3583 171.15 89.6104C171.149 89.8617 171.034 90.1023 170.831 90.2796C170.628 90.4569 170.352 90.5565 170.065 90.5565C169.779 90.5565 169.503 90.4569 169.3 90.2796C169.097 90.1023 168.982 89.8617 168.98 89.6104C168.98 89.3583 169.095 89.1165 169.298 88.9383C169.502 88.76 169.778 88.6599 170.065 88.6599Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M176.2 71.832C176.488 71.832 176.764 71.9322 176.967 72.1104C177.171 72.2887 177.285 72.5304 177.285 72.7825C177.285 73.0346 177.171 73.2763 176.967 73.4546C176.764 73.6328 176.488 73.7329 176.2 73.7329C175.912 73.7329 175.636 73.6328 175.433 73.4546C175.23 73.2763 175.115 73.0346 175.115 72.7825C175.115 72.5304 175.23 72.2887 175.433 72.1104C175.636 71.9322 175.912 71.832 176.2 71.832Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M182.335 69.4316C182.477 69.4316 182.619 69.4562 182.75 69.504C182.882 69.5518 183.001 69.6218 183.102 69.71C183.203 69.7983 183.283 69.9031 183.337 70.0184C183.392 70.1337 183.42 70.2573 183.42 70.3821C183.42 70.5069 183.392 70.6305 183.337 70.7458C183.283 70.8611 183.203 70.9659 183.102 71.0542C183.001 71.1424 182.882 71.2124 182.75 71.2602C182.619 71.308 182.477 71.3326 182.335 71.3326C182.047 71.3326 181.771 71.2324 181.568 71.0542C181.364 70.8759 181.25 70.6342 181.25 70.3821C181.25 70.13 181.364 69.8883 181.568 69.71C181.771 69.5318 182.047 69.4316 182.335 69.4316Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M188.47 66.23C188.758 66.23 189.034 66.3301 189.237 66.5084C189.44 66.6866 189.555 66.9284 189.555 67.1804C189.553 67.4318 189.439 67.6724 189.235 67.8497C189.032 68.027 188.757 68.1265 188.47 68.1265C188.183 68.1265 187.908 68.027 187.704 67.8497C187.501 67.6724 187.386 67.4318 187.385 67.1804C187.385 66.9284 187.499 66.6866 187.703 66.5084C187.906 66.3301 188.182 66.23 188.47 66.23Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M194.605 69.4316C194.892 69.4316 195.168 69.5318 195.372 69.71C195.575 69.8883 195.69 70.13 195.69 70.3821C195.69 70.6342 195.575 70.8759 195.372 71.0542C195.168 71.2324 194.892 71.3326 194.605 71.3326C194.317 71.3326 194.041 71.2324 193.837 71.0542C193.634 70.8759 193.52 70.6342 193.52 70.3821C193.52 70.13 193.634 69.8883 193.837 69.71C194.041 69.5318 194.317 69.4316 194.605 69.4316Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M200.739 72.6379C200.882 72.6379 201.023 72.6625 201.155 72.7103C201.286 72.7581 201.406 72.8281 201.507 72.9163C201.607 73.0046 201.687 73.1094 201.742 73.2247C201.796 73.34 201.824 73.4636 201.824 73.5884C201.824 73.7132 201.796 73.8368 201.742 73.9521C201.687 74.0674 201.607 74.1722 201.507 74.2605C201.406 74.3487 201.286 74.4187 201.155 74.4665C201.023 74.5143 200.882 74.5389 200.739 74.5389C200.452 74.5377 200.177 74.4372 199.974 74.2592C199.77 74.0812 199.656 73.8401 199.654 73.5884C199.654 73.3363 199.769 73.0946 199.972 72.9163C200.176 72.7381 200.452 72.6379 200.739 72.6379Z",
    fill: "white",
    stroke: "#B0BEC5",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M211.315 36.792H207.305V149.415H211.315V36.792Z",
    fill: "#DBDBDB"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M211.315 101.686H207.305V130.375H211.315V101.686Z",
    fill: "#878787"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M211.315 36.792H56.1602V43.6861H211.315V36.792Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M166.12 37.9658H66.3652V41.8553H166.12V37.9658Z",
    fill: "#EDEDED"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9551 57.8379H78.2101",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2853 58.9241C62.0254 58.9241 62.6253 58.3986 62.6253 57.7503C62.6253 57.102 62.0254 56.5764 61.2853 56.5764C60.5453 56.5764 59.9453 57.102 59.9453 57.7503C59.9453 58.3986 60.5453 58.9241 61.2853 58.9241Z",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9551 65.3584H78.2101",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2853 66.449C62.0254 66.449 62.6253 65.9234 62.6253 65.2752C62.6253 64.6269 62.0254 64.1013 61.2853 64.1013C60.5453 64.1013 59.9453 64.6269 59.9453 65.2752C59.9453 65.9234 60.5453 66.449 61.2853 66.449Z",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9551 72.8833H78.2101",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2853 73.9739C62.0254 73.9739 62.6253 73.4484 62.6253 72.8001C62.6253 72.1518 62.0254 71.6262 61.2853 71.6262C60.5453 71.6262 59.9453 72.1518 59.9453 72.8001C59.9453 73.4484 60.5453 73.9739 61.2853 73.9739Z",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9551 80.408H78.2101",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6295 80.3203C62.6295 80.0873 62.5506 79.8595 62.4028 79.6657C62.255 79.472 62.0449 79.321 61.7992 79.2318C61.5534 79.1426 61.283 79.1193 61.0221 79.1647C60.7612 79.2102 60.5215 79.3224 60.3334 79.4872C60.1453 79.652 60.0172 79.8619 59.9653 80.0905C59.9134 80.319 59.94 80.5559 60.0418 80.7712C60.1436 80.9865 60.316 81.1705 60.5372 81.3C60.7584 81.4294 61.0184 81.4985 61.2845 81.4985C61.6412 81.4985 61.9833 81.3744 62.2355 81.1534C62.4877 80.9325 62.6295 80.6328 62.6295 80.3203Z",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9551 87.9329H78.2101",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2853 89.0191C62.0254 89.0191 62.6253 88.4935 62.6253 87.8452C62.6253 87.1969 62.0254 86.6714 61.2853 86.6714C60.5453 86.6714 59.9453 87.1969 59.9453 87.8452C59.9453 88.4935 60.5453 89.0191 61.2853 89.0191Z",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M101.346 128.982L92.0011 136.625C90.8549 135.549 89.962 134.285 89.3733 132.906C88.7846 131.528 88.5118 130.061 88.5703 128.59C88.6288 127.119 89.0175 125.672 89.7143 124.332C90.411 122.993 91.4022 121.787 92.6311 120.783C94.973 118.812 98.1087 117.73 101.356 117.774L101.346 128.982Z",
    fill: "#A1A1A1"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M101.345 128.982L112.845 124.068C114.179 126.48 114.483 129.231 113.701 131.822C112.919 134.413 111.102 136.673 108.581 138.192C106.06 139.71 103.001 140.387 99.9592 140.1C96.9172 139.813 94.0935 138.58 92 136.625L101.345 128.982Z",
    fill: "#B0BEC5"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M101.346 128.982V117.774C103.754 117.728 106.125 118.299 108.168 119.417C110.211 120.536 111.837 122.152 112.846 124.068L101.346 128.982Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4643 51.1933V51.57C89.4643 51.8591 89.6143 51.9642 89.8443 51.9642C90.0743 51.9642 90.2193 51.8591 90.2193 51.57V50.694C90.2193 50.4005 90.0743 50.291 89.8443 50.291C89.6143 50.291 89.4643 50.4005 89.4643 50.694V50.8079H88.7793L88.9093 48.4602H90.8293V49.0384H89.5643L89.5043 50.0063C89.569 49.9106 89.6624 49.8322 89.7743 49.7797C89.8863 49.7272 90.0125 49.7026 90.1393 49.7085C90.6743 49.7085 90.9443 50.0414 90.9443 50.6371V51.5393C90.9443 52.1876 90.5793 52.5555 89.8643 52.5555C89.7114 52.5688 89.5571 52.551 89.4134 52.5036C89.2696 52.4562 89.1402 52.3805 89.0353 52.2822C88.9304 52.1839 88.8527 52.0658 88.8083 51.9369C88.7639 51.8081 88.754 51.6721 88.7793 51.5393V51.2021L89.4643 51.1933Z",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8809 48.9597C92.0628 48.9794 92.2465 48.9379 92.395 48.8436C92.5434 48.7493 92.6456 48.6093 92.6809 48.4517H93.1809V52.5032H92.4509V49.4109H91.8909L91.8809 48.9597Z",
    fill: "#263238"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0008 50.8869L94.7758 51.2592V52.5032H94.0508V48.4517H94.7758V50.2037L95.7258 48.4517H96.4558L95.4558 50.2562L96.4558 52.5032H95.7058L95.0008 50.8869Z",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2148 46.2703H95.6899",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M119.119 48.4909V48.1799H119.714V48.4822C120.214 48.5741 120.494 48.9202 120.494 49.472V49.5991H119.809V49.4326C119.809 49.1435 119.674 49.034 119.444 49.034C119.214 49.034 119.079 49.1435 119.079 49.4326C119.079 50.2648 120.499 50.3086 120.499 51.4649C120.54 51.6873 120.48 51.9146 120.334 52.0997C120.188 52.2848 119.966 52.4135 119.714 52.4592V52.7527H119.119V52.4592C118.868 52.4135 118.646 52.2848 118.5 52.0997C118.354 51.9146 118.294 51.6873 118.334 51.4649V51.1846H118.999V51.5043C118.999 51.7934 119.144 51.8986 119.379 51.8986C119.614 51.8986 119.754 51.7934 119.754 51.5043C119.754 50.6721 118.334 50.6284 118.334 49.472C118.354 48.9377 118.609 48.5873 119.119 48.4909Z",
    fill: "#263238"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M121.645 51.1933V51.57C121.645 51.8591 121.79 51.9642 122.02 51.9642C122.25 51.9642 122.4 51.8591 122.4 51.57V50.694C122.4 50.4005 122.255 50.291 122.02 50.291C121.785 50.291 121.645 50.4005 121.645 50.694V50.8079H120.96L121.09 48.4602H123V49.0384H121.74L121.68 50.0063C121.744 49.9103 121.838 49.8316 121.95 49.7791C122.062 49.7265 122.188 49.7021 122.315 49.7085C122.85 49.7085 123.12 50.0414 123.12 50.6371V51.5393C123.145 51.6721 123.135 51.8081 123.091 51.9369C123.047 52.0658 122.969 52.1839 122.864 52.2822C122.759 52.3805 122.63 52.4562 122.486 52.5036C122.342 52.551 122.188 52.5688 122.035 52.5555C121.325 52.5555 120.955 52.1876 120.955 51.5393V51.2021L121.645 51.1933Z",
    fill: "#263238"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M124.061 48.9597C124.243 48.9794 124.426 48.9379 124.575 48.8436C124.723 48.7493 124.825 48.6093 124.861 48.4517H125.361V52.5032H124.636V49.4109H124.076L124.061 48.9597Z",
    fill: "#263238"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M127.18 50.8869L126.955 51.2592V52.5032H126.225V48.4517H126.955V50.2037L127.905 48.4517H128.63L127.63 50.2562L128.63 52.5032H127.885L127.18 50.8869Z",
    fill: "#263238"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M120.27 46.2703H126.745",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M148.301 49.4238C148.301 49.1671 148.417 48.9209 148.624 48.7393C148.832 48.5578 149.113 48.4558 149.406 48.4558C149.699 48.4558 149.98 48.5578 150.187 48.7393C150.394 48.9209 150.511 49.1671 150.511 49.4238V51.5306C150.511 51.7873 150.394 52.0335 150.187 52.215C149.98 52.3966 149.699 52.4986 149.406 52.4986C149.113 52.4986 148.832 52.3966 148.624 52.215C148.417 52.0335 148.301 51.7873 148.301 51.5306V49.4238ZM149.031 51.57C149.031 51.8591 149.176 51.9686 149.406 51.9686C149.636 51.9686 149.781 51.8591 149.781 51.57V49.38C149.781 49.0865 149.636 48.977 149.406 48.977C149.176 48.977 149.031 49.0865 149.031 49.38V51.57Z",
    fill: "#263238"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M151.68 51.8899V52.5031H151V51.8899H151.68Z",
    fill: "#263238"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M153.61 49.4458C153.61 49.0822 153.465 48.9815 153.235 48.9815C153.005 48.9815 152.855 49.091 152.855 49.3844V49.6429H152.17V49.4239C152.17 48.7756 152.54 48.4033 153.255 48.4033C153.97 48.4033 154.335 48.7756 154.335 49.4239V49.529C154.364 49.6963 154.331 49.8673 154.241 50.017C154.151 50.1668 154.009 50.2874 153.835 50.3612C154.008 50.4401 154.15 50.5642 154.239 50.7164C154.329 50.8686 154.362 51.0414 154.335 51.2109V51.5306C154.335 52.1789 153.965 52.5468 153.255 52.5468C153.102 52.5601 152.948 52.5423 152.804 52.4949C152.66 52.4475 152.531 52.3718 152.426 52.2735C152.321 52.1752 152.243 52.0571 152.199 51.9282C152.155 51.7994 152.145 51.6634 152.17 51.5306V51.1934H152.855V51.5701C152.855 51.8591 153 51.9686 153.235 51.9686C153.47 51.9686 153.61 51.8723 153.61 51.5306V51.2109C153.61 50.8342 153.465 50.6984 153.11 50.6984H152.865V50.1159H153.15C153.42 50.1159 153.585 50.0152 153.585 49.6779L153.61 49.4458Z",
    fill: "#263238"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M154.785 49.0561C154.785 48.8934 154.859 48.7375 154.99 48.6225C155.121 48.5075 155.3 48.4429 155.485 48.4429C155.671 48.4429 155.849 48.5075 155.98 48.6225C156.111 48.7375 156.185 48.8934 156.185 49.0561V50.3701C156.185 50.5327 156.111 50.6887 155.98 50.8037C155.849 50.9187 155.671 50.9833 155.485 50.9833C155.3 50.9833 155.121 50.9187 154.99 50.8037C154.859 50.6887 154.785 50.5327 154.785 50.3701V49.0561ZM155.25 50.4182C155.25 50.5978 155.335 50.6723 155.485 50.6723C155.635 50.6723 155.725 50.5978 155.725 50.4182V49.0561C155.725 48.8765 155.63 48.7976 155.485 48.7976C155.34 48.7976 155.25 48.8765 155.25 49.0561V50.4182ZM157.31 48.4385H157.74L155.915 52.49H155.5L157.31 48.4385ZM157.08 50.5365C157.08 50.3739 157.154 50.2179 157.285 50.1029C157.416 49.9879 157.594 49.9233 157.78 49.9233C157.966 49.9233 158.144 49.9879 158.275 50.1029C158.406 50.2179 158.48 50.3739 158.48 50.5365V51.8505C158.48 52.0131 158.406 52.1691 158.275 52.2841C158.144 52.3991 157.966 52.4637 157.78 52.4637C157.594 52.4637 157.416 52.3991 157.285 52.2841C157.154 52.1691 157.08 52.0131 157.08 51.8505V50.5365ZM157.54 51.8987C157.54 52.0783 157.63 52.1527 157.78 52.1527C157.93 52.1527 158.015 52.0783 158.015 51.8987V50.5102C158.015 50.3306 157.925 50.2562 157.78 50.2562C157.635 50.2562 157.54 50.3306 157.54 50.5102V51.8987Z",
    fill: "#263238"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M150.154 46.2703H156.629",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4643 106.872V107.249C89.4643 107.538 89.6143 107.643 89.8443 107.643C90.0743 107.643 90.2193 107.538 90.2193 107.249V106.373C90.2193 106.084 90.0743 105.974 89.8443 105.974C89.6143 105.974 89.4643 106.084 89.4643 106.373V106.495H88.7793L88.9093 104.143H90.8293V104.682H89.5643L89.5043 105.646C89.5704 105.551 89.6643 105.474 89.776 105.423C89.8877 105.371 90.0132 105.347 90.1393 105.352C90.6743 105.352 90.9443 105.681 90.9443 106.276V107.179C90.9443 107.827 90.5793 108.199 89.8643 108.199C89.1493 108.199 88.7793 107.827 88.7793 107.179V106.872H89.4643Z",
    fill: "#263238"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8809 104.621C92.0638 104.641 92.2487 104.599 92.3975 104.504C92.5464 104.409 92.6478 104.267 92.6809 104.108H93.1809V108.16H92.4509V105.072H91.8909L91.8809 104.621Z",
    fill: "#263238"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0008 106.548L94.7758 106.916V108.16H94.0508V104.108H94.7758V105.86L95.7258 104.108H96.4558L95.4558 105.917L96.4558 108.16H95.7058L95.0008 106.548Z",
    fill: "#263238"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2148 101.927H95.6899",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4707 110.726H96.5307",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4707 112.627H96.5307",
    stroke: "black",
    strokeWidth: 1.02486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChart);
export default __webpack_public_path__ + "static/media/emptyChart.68c204eff974ab3e40cb6a5421affaad.svg";
export { ForwardRef as ReactComponent };